import { render } from "./systemSelection.vue?vue&type=template&id=81eb4fb2&scoped=true"
import script from "./systemSelection.vue?vue&type=script&lang=js"
export * from "./systemSelection.vue?vue&type=script&lang=js"

import "./systemSelection.vue?vue&type=style&index=0&id=81eb4fb2&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81eb4fb2"]])

export default __exports__